import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { AppLanguageType } from "../config";
import { DEFAULT_LANGUAGE } from "../config";
import { logI18nSetup } from "../init";

export const useCurrentLanguage = (): AppLanguageType => {
  const { i18n } = useTranslation();
  const language = (i18n.language as AppLanguageType) ?? DEFAULT_LANGUAGE;

  useEffect(() => logI18nSetup(), [language]);

  return language;
};
